(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pbj-faq"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqBlocks = document.querySelectorAll('.faq-block');

  faqBlocks.forEach(function(block) {
    const header = block.querySelector('.faq-header');

    header.addEventListener('click', function() {
      block.classList.toggle('active');
      const content = block.querySelector('.faq-content');
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbj-header"]) return;
  try {
    
    $(".main-nav__item.main-nav__has-dropdown").on("focusin", function() {
      // Remove the class from all items before adding it to the focused item
      $(".main-nav__item.main-nav__has-dropdown").removeClass("show-dropdown");
      $(this).addClass("show-dropdown");
    });

  // Toggle the search form display when the search icon is clicked
  $('.custom-js-header-search-trigger').on('click', function (e) {
    e.preventDefault(); // Prevent default anchor behavior
    $('.custom-header-search-form').slideToggle(); // Toggle mobile-specific search form visibility
  });

  // // Add the .active class when hovering over elements with class .show-dropdown
  // $(document).on('mouseenter', '.show-dropdown', function() {
  //   if ($('.show-dropdown').is(':hover')) {
  //     $('.header-overlay').addClass('active');
  //   }
  //   $('.header-overlay').removeClass('active');
  // });
  // // Add the .active class when hovering over elements with class .show-dropdown
  // $(document).on('mouseleave', '.main-nav__dropdown' function() {
  //   $('.header-overlay').removeClass('active');
  // });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbj-product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendationsAndInitSwiper() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        var mySwiper = new Swiper('.swiper-container', {
          init: false,
          freeMode: false,
          slidesPerView: 4,
          autoHeight: false,
          grabCursor: true,
          effect: 'slide',
          centeredSlides: false,
          spaceBetween: 14,
          navigation: {
            nextEl: '.carousel-next',
            prevEl: '.carousel-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true, // Optional: Makes pagination dots clickable
          },
          autoplay: false,
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            560: {
              spaceBetween: 12,
              freeMode: true,
              slidesPerView: 2,
            },
          },
        });
        
        mySwiper.init();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setTimeout(loadProductRecommendationsAndInitSwiper, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
